import { useRef } from 'react'
import { CONFIG } from '@/config/constants'

// SnapWidget URL（iframe埋め込み）
const snapWidgetUrl = import.meta.env.VITE_SNAPWIDGET_URL

export function BlogInstagram() {
  const scrollRef = useRef<HTMLDivElement>(null)

  const scroll = (direction: 'left' | 'right') => {
    if (!scrollRef.current) return
    const scrollAmount = 300
    scrollRef.current.scrollBy({
      left: direction === 'left' ? -scrollAmount : scrollAmount,
      behavior: 'smooth',
    })
  }

  return (
    <section id="blog-instagram" className="blog-instagram-section">
      <div className="container">
        <div className="blog-instagram-grid">
          {/* Blog Section - Coming Soon */}
          <div className="blog-section">
            <h2 className="section-title">ブログ</h2>
            <div className="blog-grid">
              <div className="blog-coming-soon">
                <p className="coming-soon-title">Coming Soon</p>
                <span className="coming-soon-text">準備中です</span>
              </div>
            </div>
          </div>

          {/* Instagram Section */}
          <div className="instagram-section">
            <h2 className="section-title">Instagram</h2>
            <div className="instagram-feed">
              {snapWidgetUrl ? (
                <div className="instagram-scroll-wrapper">
                  <button
                    type="button"
                    className="instagram-nav instagram-nav--left"
                    onClick={() => scroll('left')}
                    aria-label="前の投稿を見る"
                  >
                    ‹
                  </button>

                  <div className="instagram-scroll-container" ref={scrollRef}>
                    <iframe
                      src={snapWidgetUrl}
                      className="snapwidget-widget"
                      title="Posts from Instagram"
                      loading="lazy"
                    />
                  </div>

                  <button
                    type="button"
                    className="instagram-nav instagram-nav--right"
                    onClick={() => scroll('right')}
                    aria-label="次の投稿を見る"
                  >
                    ›
                  </button>
                </div>
              ) : (
                <div className="instagram-fallback">
                  <a
                    href={CONFIG.STORE.instagramUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="instagram-fallback__link"
                  >
                    <i className="fab fa-instagram"></i>
                    <span>Instagramで見る</span>
                  </a>
                </div>
              )}
            </div>
            <div className="instagram-link">
              <a
                href={CONFIG.STORE.instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                @breadshopkamando をフォロー
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
